'use client';

import { Button, InputField } from '@pickleballinc/react-ui';
import { RecaptchaNotice } from '@pickleballinc/ui/components/ui/recaptcha-notice';

import { useNewsletterSubscribeForm } from '@/hooks/newsletter/useSubscribeNewsletterForm';
import { subscribeToNewsletter } from '@/utils/actions/homepage/subscribeToNewsletter';
import { CaptchaAction } from '@/utils/helpers/captcha-actions';
import { NEWSLETTER_IMAGE_URL, PRIVACY_POLICY_URL } from '@/utils/helpers/constants';

export const RenderNewsletter = () => {
  const { email, onEmailChange, handleSubscribe, displayError, isPending, isSuccess } =
    useNewsletterSubscribeForm(subscribeToNewsletter, CaptchaAction.NEWSLETTER_SUBSCRIBE);

  return (
    <div className='flex min-h-[288px] w-full items-center justify-center'>
      <div
        className='flex items-center justify-center p-6 rounded-lg h-full w-full bg-transparent'
        style={{
          backgroundImage: `url(${NEWSLETTER_IMAGE_URL})`,
          backgroundPosition: 'center top',
          backgroundSize: 'cover',
        }}
      >
        <div className='flex flex-col gap-6'>
          <div className='flex flex-col gap-4'>
            <h2 className='text-white font-semibold'>Get the Latest Pickleball News</h2>
            <p className='text-white text-xs leading-[18px]'>
              Be in the know - 200k+ subscribers. <br /> {`5 minute emails. 1 weekly update.`}
            </p>
          </div>

          <div className='flex flex-col gap-4'>
            <div className='flex flex-col gap-2'>
              <InputField
                className='!rounded-lg !px-1.5 !shadow-xs'
                value={email}
                id='email'
                type='email'
                hasError={!!displayError}
                placeholder='Enter your email'
                onChange={(e) => {
                  onEmailChange(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleSubscribe();
                  }
                }}
                disabled={isPending}
              />
              {displayError ? <span className='text-error-400 text-sm'>{displayError}</span> : null}
            </div>
            <Button
              size='sm'
              variant='primary'
              className='!w-full !justify-center'
              onClick={handleSubscribe}
              disabled={isPending}
            >
              {isPending ? 'Subscribing...' : 'Subscribe'}
            </Button>
            <span className='text-white text-xs leading-[18px]'>
              {`We care about your data in our `}
              <a
                href={PRIVACY_POLICY_URL}
                target='_blank'
                rel='noopener noreferrer'
                className='underline'
                aria-label={`Link to ${PRIVACY_POLICY_URL} (opens in a new tab)`}
              >
                privacy policy
              </a>
              .
            </span>
            <RecaptchaNotice className='text-white text-xs leading-[18px]' />
            {isSuccess ? (
              <span className='text-green-200 text-xs'>{`You're subscribed!`}</span>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};
